<template>
  <div  style="background-color: #f8f8f8;min-height: 100%;padding:10px;">
    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <a @click="modal1=true">更新退订</a>
        <cite>|</cite>
        <a @click="load">刷新</a>
      </div>
    </Card>

    <Row style="margin-top:10px">
      <Col span="24">
        <Card :bordered="false"  dis-hover>
          <p slot="title">退订列表（{{count}}）
          </p>
          <el-table
            :data="list"
            size="small"
            style="width: 100%">
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column prop="name" label="联系人名称"></el-table-column>
          </el-table>
        </Card>
      </Col>
    </Row>

    <Card  :bordered="false" dis-hover style="text-align: center">
      <Page :total="count" show-total :page="page"   show-elevator @on-change="change"></Page>
    </Card>

    <Modal
      v-model="modal1"
      width="600"
      title="输入退订邮箱，一行一个"
      @on-ok="save"
      @on-cancel="cancel">
      <Input type="textarea" placeholder="输入退订邮箱，一行一个" v-model="form.names" :autosize="{minRows: 12,maxRows: 12}" ></Input>
    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        list:[],
        page:1,
        count:0,
        modal1:false,
        form:{
          names:'',
        }
      }
    },
    methods:{
      change(val){
        this.page = val;
        this.load();
      },
      load(){
        let that = this;
        this.$axios.get('/api/contact/findall?page='+this.page+'&limit=10').then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
        });
      },
      save(){
        let that = this;
        this.$axios({url:'/api/contact/save',method:'post',data:this.$qs.stringify(this.form)}).then(function(rs){
          that.toast(rs.data);
        });
      },
      remove(){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除所有发件箱吗（不可恢复）',
          onOk: () => {
            let that = this;
            this.$axios.get('/api/outbox/removeAll').then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      outFile(state){
        window.location = '/api/client/out?state='+state
      },
      toast(data){
        if(data.success){
          this.$Message.success(data.msg);
          this.load();
        }else{
          this.$Message.error(data.msg+"，请确保邮箱地址不重复");
        }
      }

    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/Contact.vue